export default __webpack_public_path__ + "static/media/modelLynnMinting.c28b0a68.png";